module.exports = __webpack_public_path__ + "img/tarjetas-de-credito-gray.c63f2087.svg";